export default "__VITE_ASSET__Da6hsl84__"